import { lang } from '@umu/ukit-lang';
/**
 * @description 密码输入框，带显示明文密码的功能
 * @author wayou
 */

import './mailInput.scss';

import React, { Component, createRef, RefObject } from 'react';
import { $window, classSet } from '@umu/umu-dom';
import { components } from 'common';
const { If } = components;
const { AlertDialog: alert } = components;

const RECOMMEND_MAIL_VENDORS = [
    'qq.com',
    '163.com',
    '126.com',
    'sina.com',
    'gmail.com',
    'hotmail.com',
    'sohu.com',
    '139.com',
    '189.com',
    '21cn.com',
];

interface IProps {
    clsName?: string;
    placeholder: string;
    initialVal?: string;
    mailVendors?: string[];
    changeCallback: (value: string) => void;
    tooltip?: string;
    isShowSuggestion: boolean; // determine if show email suggestion
}

interface IState {
    showSugg: boolean;
    mailVendors: string[];
}

class MailInput extends Component<IProps, IState> {
    public static defaultProps = {
        placeholder: lang('电子邮箱/用户名'),
        mailVendors: RECOMMEND_MAIL_VENDORS,
        isShowSuggestion: true,
    };

    public hideSuggTimeout: number = 0;
    public elRef: RefObject<HTMLInputElement>;

    constructor(props: IProps) {
        super(props);
        this.state = {
            showSugg: false,
            mailVendors: props.mailVendors || RECOMMEND_MAIL_VENDORS,
        };

        this.elRef = createRef();

        this.changeCallback = this.changeCallback.bind(this);
        this.showSugg = this.showSugg.bind(this);
        this.hideSugg = this.hideSugg.bind(this);
        this.mailInputBlur = this.mailInputBlur.bind(this);
        this.showTooltip = this.showTooltip.bind(this);
    }

    public componentWillUnmount() {
        clearTimeout(this.hideSuggTimeout);
    }

    public getClassName(clsName?: string) {
        let classObj = {
            'input lined': true,
            'mail-wrap': true,
        };
        if (clsName) {
            classObj = Object.assign(classObj, {
                [clsName]: true,
            });
        }
        return classSet(classObj);
    }

    public changeCallback() {
        const el = this.elRef.current;
        if (!el) {
            return;
        }

        const val = el.value || '';

        // 检查是否有@
        const atIndex = val.indexOf('@');
        if (atIndex > -1) {
            // 看是不是刚输入的，如果是则显示 suggestion，如果不是则根据新的输入更新 suggestion 列表
            if (atIndex === val.length - 1) {
                this.showSugg();
                this.setState({
                    mailVendors: this.props.mailVendors || RECOMMEND_MAIL_VENDORS,
                });
            } else {
                const domainStr = val.split('@')[1];
                const matches = (this.props.mailVendors || RECOMMEND_MAIL_VENDORS).filter((item) => {
                    return item.toUpperCase().indexOf(domainStr.toUpperCase()) === 0;
                });

                this.setState({
                    mailVendors: matches,
                });
            }
        } else {
            this.hideSugg();
        }

        this.props.changeCallback(val);
    }

    public domainSelect(domain: string) {
        const el = this.elRef.current;
        if (!el) {
            return;
        }

        let inputVal = el.value || '';
        inputVal = inputVal.split('@')[0] + '@' + domain;

        el.value = inputVal;
        this.props.changeCallback(inputVal);
        this.hideSugg();
    }

    public showSugg() {
        const el = this.elRef.current;
        if (!el) {
            return;
        }

        const inputVal = el.value || '';
        if (inputVal.indexOf('@') > -1) {
            this.setState({
                showSugg: true,
            });
        }
    }

    public hideSugg() {
        this.setState({
            showSugg: false,
        });
    }

    public mailInputBlur() {
        this.hideSuggTimeout = $window.setTimeout(() => {
            this.hideSugg();
        }, 500);
    }
    // 后来者们：li 的点击在 ios 上，点击 textNode 不会触发，处理方法是加了个内层的 span 并带上空的 onclick 属性
    // https://github.com/facebook/react/issues/134
    public renderSugg() {
        if (!this.props.isShowSuggestion) {
            return null;
        }
        const el = this.elRef.current;
        if (!el) {
            return;
        }

        const inputVal = el.value || '';
        const suffix = inputVal && inputVal.split('@')[0];
        return (
            <ul className="domain-wrap" style={{ display: this.state.showSugg ? 'block' : 'none' }}>
                {this.state.mailVendors.map((item, index) => {
                    return (
                        <li key={index} onClick={this.domainSelect.bind(this, item)}>
                            {suffix}@{item}
                        </li>
                    );
                })}
            </ul>
        );
    }

    public showTooltip() {
        const props = this.props;
        const tooltip = props.tooltip || '';
        alert({
            title: '',
            content: tooltip,
        });
    }

    public render() {
        const props = this.props;

        return (
            <div className={this.getClassName(props.clsName)}>
                <If condition={!!this.props.tooltip}>
                    <a className="input-tooltip" onClick={this.showTooltip}>
                        <i className="icon icon-entity entity-tooltip" />
                    </a>
                </If>
                <input
                    type="email"
                    ref={this.elRef}
                    defaultValue={props.initialVal}
                    placeholder={props.placeholder}
                    onChange={this.changeCallback}
                    onBlur={this.mailInputBlur}
                    onFocus={this.showSugg}
                />
                {this.renderSugg()}
            </div>
        );
    }
}

export default MailInput;
